export const environment = {
  production: false,
  ENCRYPT_LOCAL_STORAGE: false,
  LOCAL_STORAGE_SECRET: '0b7d48bcc19635088f48df006fa23a747b60',
  API_BASE_URL: 'https://devapi.bugatlas.com/v1/',
  SOCKET_URL: 'https://devapi.bugatlas.com:8000',

};
